import terms from '@/content/legal/terms-of-service.md?raw';
import { Container, useTheme } from '@mui/material';

import { LegalMarkdown } from '@/components/Marketing/LegalMarkdown';
import { usePageMeta } from '@/hooks/usePageMeta';

export const TermsOfService = () => {
  const theme = useTheme();
  usePageMeta(
    'Terms of Service',
    'Terms and conditions for using Unbeatable Loans mortgage brokering and related services.'
  );
  return (
    <Container sx={{ py: 5, color: theme.palette.text.primary }}>
      <LegalMarkdown content={terms} />
    </Container>
  );
};
